<template>
  <el-row v-loading="isLoading">
    <el-row class="condition-row" type="flex" justify="center">
      <el-col :md="12" :sm="24">
        <el-form class="from-to-form" :inline="true" :model="form" ref="dateForm">
          <el-row type="flex" align="middle">
            <label>表示期間：</label>
            <el-form-item class="form-item">
              <el-date-picker
                v-model="form.dateFrom"
                type="date"
                placeholder="yyyy年mm月dd日"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :disabled="disabled"
                :editable="isEditable"
                :pickerOptions="spPickerOptions"
              />
            </el-form-item>
            <label>～</label>
            <el-form-item class="form-item">
              <el-date-picker
                v-model="form.dateTo"
                type="date"
                placeholder="yyyy年mm月dd日"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                :disabled="disabled"
                :editable="isEditable"
                :pickerOptions="spPickerOptions"
              />
            </el-form-item>
          </el-row>

          <el-row type="flex" align="middle">
            <label>休日区分：</label>
            <el-form-item class="form-item">
              <el-radio-group :disabled="disabled" v-model="form.holiday">
                <el-radio label="all">期間全体</el-radio>
                <el-radio label="weekdays">平日</el-radio>
                <el-radio label="holidays">休日</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>

          <el-row type="flex" align="middle">
            <label>属性：</label>
            <el-form-item class="form-item">
              <el-radio-group :disabled="disabled" v-model="form.attribute">
                <el-radio label="age">年齢</el-radio>
                <el-radio label="gender">性別</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
        </el-form>
      </el-col>
      <el-col :md="12" :sm="24">
        <StreamList @check="changeStreamList" :authStatus="disabled"></StreamList>
      </el-col>
    </el-row>
    <el-row class="button-row">
      <el-button type="primary" :disabled="disabled" @click="getData">表示</el-button>
    </el-row>
  </el-row>
</template>

<script>
import StreamList from '@/components/StreamList.vue'

export default {
  name: 'ConditionForms',
  components: {
    StreamList
  },
  props: {
    disabled: Boolean
  },

  data() {

    return {
      form: {
        dateFrom: "",
        dateTo: "",
        holiday: "all",
        attribute: "age",
        streamList: []
      },
      isLoading: false,
      isEditable: false,
      spPickerOptions: {
        disabledDate(time) {
          let dt = new Date()
          let today = dt.setDate(dt.getDate())
          let lastyear = dt.setFullYear(dt.getFullYear() - 1)
          return time.getTime() >= today || time.getTime() < lastyear
        }
      },
    }
  },

  methods: {
    getData: function () {
      this.isLoading = true
      let action = ""
      if (this.form.attribute == "age") {
        action = "getHourlyAgeData"
      } else {
        action = "getHourlyGenderData"
      }

      let params = {
        dateFrom: this.form.dateFrom,
        dateTo: this.form.dateTo,
        condition: this.form.holiday,
        streamList: this.streamList
      }

      this.$store.dispatch(action, params)
        .then(() => {
          // loading終了処理
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    changeStreamList: function (streamList) {
      this.streamList = streamList
    },

  },
  async created() {

  }

};
</script>

<style scoped>
.active-date {
  padding: 20px;
  font-size: 15px;
}

.form-item {
  margin: auto 5px;
}

.button-row {
  margin-top: 10px;
}
</style>
